import { render, staticRenderFns } from "./gl-footer-menu-profile.vue?vue&type=template&id=2b9705fc"
import script from "./gl-footer-menu-profile.vue?vue&type=script&lang=js"
export * from "./gl-footer-menu-profile.vue?vue&type=script&lang=js"
import style0 from "./gl-footer-menu-profile.vue?vue&type=style&index=0&id=2b9705fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports